import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {withFirebase} from 'react-redux-firebase';

import withStyles from "@material-ui/core/styles/withStyles";
import {FacebookLoginButton} from "react-social-login-buttons";
import {GoogleLoginButton} from "react-social-login-buttons";
import {TwitterLoginButton} from "react-social-login-buttons";

import loginPageStyle from 'assets/jss/material-kit-react/views/loginPage.jsx';
import {loginWithSocial} from "actions/firebase_actions.js"

class SocialMediaLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedIn: null,
    };
  }

  render(){
    const {classes, loginWithSocial, history} = this.props;

    return (
      <div>
        <div className={classes.socialLoginContainer}>
          <div style={{width: 300}}>
            <FacebookLoginButton onClick={() => loginWithSocial("facebook", history)}>
              <span>Connect with Facebook</span>
            </FacebookLoginButton>
          </div>
          <div style={{width: 300}}>
            <GoogleLoginButton onClick={() => loginWithSocial("google", history)}>
              <span>Connect with Google</span>
            </GoogleLoginButton>
          </div>
          <div style={{width: 300}}>
            <TwitterLoginButton onClick={() => loginWithSocial("twitter", history)}>
              <span>Connect with Twitter</span>
            </TwitterLoginButton>
          </div>
        </div>
        <p className={classes.divider}>Or keep it simple, use your email</p>
      </div>
    );
  }
}

const pageWithStylesAndFirebase = withStyles(loginPageStyle)(withFirebase(SocialMediaLogin));
function mapStateToProps(state) {
  return {
    auth: state.firebase.auth,
    profile: state.profile,
  };
}

export default withRouter(connect(mapStateToProps, {loginWithSocial})(pageWithStylesAndFirebase));



// WEBPACK FOOTER //
// ./src/components/SocialLogins/SocialLogins.jsx